export default __webpack_public_path__ + "static/media/imagem-1.c479b73a.png";